module.exports = __webpack_public_path__ + "static/media/logo.016cbfa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 979
// module chunks = 0